import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
import { Link } from 'react-router-dom';

interface AppWordmarkProps {
  name: string;
  href?: string;
  showName?: boolean;
  /** Second line under the name (e.g. version + status), aligned to the right of the logo. */
  meta?: ReactNode;
  className?: string;
  logoClassName?: string;
}

const titleClassName = 'text-fin-white truncate text-sm font-medium tracking-tight';

/** Fintecy text logo mark + optional wordmark (matches breadcrumb title styling). */
export const AppWordmark = ({
  name,
  href = '/accounts',
  showName = true,
  meta,
  className,
  logoClassName,
}: AppWordmarkProps) => {
  const wordmarkText = name.startsWith('(F)') ? `F${name.slice(3)}` : name;

  const logo = (
    <span
      className={cn(
        'font-architects flex size-8 shrink-0 items-center justify-center rounded-lg bg-black text-sm font-bold tracking-tight text-white',
        logoClassName
      )}
      aria-hidden
    >
      (F)
    </span>
  );

  if (!showName) {
    return <span className={cn('inline-flex shrink-0', className)}>{logo}</span>;
  }

  if (meta) {
    return (
      <div className={cn('flex min-w-0 items-start gap-2.5', className)}>
        <Link to={href} className='shrink-0' aria-label={name}>
          {logo}
        </Link>
        <div className='flex min-w-0 flex-1 flex-col gap-0.5 pt-0.5'>
          <Link to={href} className={titleClassName}>
            {wordmarkText}
          </Link>
          {meta}
        </div>
      </div>
    );
  }

  return (
    <Link
      to={href}
      className={cn('flex min-w-0 items-center gap-2.5', className)}
      aria-label={name}
    >
      {logo}
      <span className={titleClassName}>{wordmarkText}</span>
    </Link>
  );
};

export default AppWordmark;
